<ng-container *ngIf="(selectedOrganization$ | async) as selectedOrganization">
  <ng-container *ngIf="(isGetFloorsLoaded$ | async) as isGetFloorsLoaded; else loadingFloors">
    <awair-floor-plan-header class="__header"
                             [hasFloor]="hasFloor$ | async"
                             [floorName]="(selectedFloor$ | async)?.name"
                             [selectedAirComponent]="selectedAirComponent$ | async"
                             [isSidebarOpened]="isSidebarOpened"
                             (openEditor)="onOpenEditor($event)"
                             (toggleSidebar)="onToggleSidebar($event)"
                             (selectAirComponent)="onSelectAirComponent($event)">
    </awair-floor-plan-header>

    <div class="__body"
         [ngSwitch]="hasFloor$ | async">
      <awair-backdrop *ngIf="isSidebarOpened"
                      [backgroundColor]="'#212528'"
                      [opacity]="'0.1'">
      </awair-backdrop>
      <!-- Sidebar -->
      <awair-floor-plan-sidebar class="__sidebar"
                                *ngIf="isSidebarOpened"
                                [floors]="floors$ | async"
                                [selectedFloorId]="selectedFloorId$ | async"
                                [devicesWithPolledAirData]="devicesWithPolledAirData$ | async"
                                (selectFloor)="onSelectFloor($event)"
                                (selectDevice)="onSelectDeviceFromList($event)">
      </awair-floor-plan-sidebar>
      <!-- /.Sidebar -->

      <!-- Snapshot -->
      <div class="__snapshot-container"
           *ngIf="(selectedDeviceSnapshots$ | async)?.length > 0">
        <button class="__close-button"
                (click)="onCloseSnapshot()">
          <span class="__button-wrapper">
            <awair-cross-icon [color]="'#FFFFFF'"
                              [size]="{width: 14, height: 14}">
            </awair-cross-icon>
          </span>
        </button>
        <awair-snapshot class="__snapshot"
                        [snapshots]="selectedDeviceSnapshots$ | async">
        </awair-snapshot>
      </div>
      <!-- /.Snapshot -->

      <!-- Floor Plan Map -->
      <awair-floor-plan-map *ngSwitchCase="true"
                            [mapUrl]="(selectedFloor$ | async)?.floorPlan?.imageUrl"
                            [deviceMarkers]="selectedFloorPlanDeviceMarkers$ | async"
                            (selectDevice)="onSelectDeviceMarker($event)"
                            (deselectDevice)="onDeselectDeviceMarker($event)">
      </awair-floor-plan-map>
      <!-- /. Floor Plan Map -->

      <!-- Empty View -->
      <awair-floor-plan-empty *ngSwitchDefault
                              (openEditor)="onOpenEditor($event)">
      </awair-floor-plan-empty>
      <!-- /.Empty View -->

    </div>
  </ng-container>

  <ng-template #loadingFloors>
    <awair-loading></awair-loading>
  </ng-template>
</ng-container>
